import React from 'react';
import { useIntl } from 'react-intl';
import Modal from 'react-modal';
import { AvailableForPurchaseProduct } from '../../../../../../../interfaces/merchants/resources/books';
import css from './BookingPurchaseProduct.module.scss';
import { RSButton } from 'src/reservation-page/RSButton';
import { buildSiteUrl } from 'src/utils/request-url';

interface Props {
  product: AvailableForPurchaseProduct;
}

Modal.setAppElement('#__next');

const BookingPurchaseProduct: React.FC<Props> = ({ product }) => {
  const intl = useIntl();

  const handleModalOpen = () => {
    // 別タブで購入画面を開く
    window.open(
      buildSiteUrl(`/products/${product.public_id}/purchase`),
      '_blank',
    );
  };

  return (
    <div key={product.public_id}>
      <div className={css.outer}>
        <div className={css.productNameSection}>
          <div onClick={handleModalOpen}>
            {`${product.name} （${intl.formatMessage(
              { id: 'common.price' },
              { price: intl.formatNumber(product.price) },
            )})`}
          </div>
        </div>
        <div className={css.buttonSection}>
          <div>
            <RSButton variant="outline" onClick={handleModalOpen}>
              {intl.formatMessage({ id: 'books.button.purchase' })}
            </RSButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingPurchaseProduct;
